import { ElementRef } from '@angular/core';
import { get, keys } from 'lodash';
import { shouldShowShape } from '../../../cross-team-shared/annotation/shared/state/shape-location-state';
import {
  forbiddenCursor,
  removeCursor,
  subpointCursor,
} from '../../../cross-team-shared/cursors/custom-cursors';
import { setCssProperty } from '../../../cross-team-shared/misc-utils';
import { ViewMode } from '../../../cross-team-shared/state/abstract-sensor-content-state';
import { VectorLayerEditMode } from '../../../cross-team-shared/types/tool-modes';
import {
  Point2D,
  VisibilityState,
} from '../../../team-apis/otterdam/answers/shape-typings';
import { Selection } from '../state/abstract-sensor-content-state-2d';

export function buildSubpoints([selection, index, points]: [
  Selection,
  number,
  Point2D[],
]) {
  const selectedSubpointIndexes = keys(get(selection, [index]));
  return points.map((point, subpointIndex) => ({
    subpointIndex,
    point,
    selected: selectedSubpointIndexes.includes(subpointIndex.toString()),
  }));
}

export function updateCursorSubpointsDelete(
  [isRemove, enoughPoints, isSelected]: [boolean, boolean, boolean],
  hasFocusedShapeStore: boolean,
  elementRef: ElementRef<SVGElement>,
) {
  let cursor = null;
  if (isRemove && hasFocusedShapeStore && isSelected) {
    cursor = enoughPoints ? removeCursor : forbiddenCursor;
  }
  setSubpointCursor(elementRef, cursor);
}

export function updateCursorSubpointsAdd(
  [editMode, isSelected]: [VectorLayerEditMode, boolean],
  elementRef: ElementRef<SVGElement>,
) {
  if (editMode === 'remove') {
    return;
  }
  const isInAddMode = editMode === 'add';
  setSubpointCursor(
    elementRef,
    isInAddMode && isSelected ? subpointCursor : null,
  );
}

export function buildDisplay(
  {
    visibility,
    viewMode,
    isSelected,
    isTrainingShape,
  }: {
    visibility: VisibilityState;
    viewMode: ViewMode;
    isSelected: boolean;
    isTrainingShape: boolean;
  },
  isInOverlay: boolean,
) {
  const isVisibleTrainingShape = visibility > 0 && isTrainingShape;

  if (
    isInOverlay ||
    isVisibleTrainingShape ||
    shouldShowShape(visibility, viewMode, isSelected)
  ) {
    return 'unset';
  } else {
    return 'none';
  }
}

export function setSubpointCursor(
  elementRef: ElementRef<SVGElement>,
  cursor: string | null,
) {
  setCssProperty(elementRef, '--h3-subpoint-cursor', cursor);
  setCssProperty(elementRef, '--h3-polygon-subpoint-cursor', cursor);
}

export function getPointString(points: Point2D[]) {
  return points.map((p) => p.join(',')).join(' ');
}
